const ticketStatuses = ['active', 'pending', 'expired', 'cancelled', 'failed', 'unknown'] as const;
export type TicketStatus = typeof ticketStatuses[number];

export const parseTicketStatus = (value: string): TicketStatus => {
  if (ticketStatuses.includes(value as TicketStatus)) {
    return value as TicketStatus;
  }
  throw new Error(`${value} is not a valid TicketStatus`);
};
